<template>
  <div id="standardQuestion" style="min-height: calc(100vh - 32px)">
    <div class="margin-subpages">
      <div class="flex-row-between">
        <div class="flex-center">
          <el-input class="input-style" style="width: 240px !important;" autosize :placeholder="$t('questions.Search')"
            v-model="inputSearch" clearable></el-input>
          <div class="flex-center drop-down-container ml-auto"
            :class="`${questionFilterList.length > 0 ? 'active' : ''}`">
            <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownValuesMenu">
              <div class="text-drop-down flex-mid">
                <span v-if="questionFilterList.length > 0">
                  ({{ questionFilterList.length }})&nbsp;
                </span>
                <div>Question Type</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button @click="handleSelectAllQuestionType" class="dropdownHeaderTextStyle" type="text">{{
                      $t("powerUp.Select_all") }}</el-button>
                    <el-button @click="checkedQuestionType = []" class="dropdownHeaderTextStyle"
                      style="margin-left: 24px" type="text">{{ $t("powerUp.Clear") }}</el-button>
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the type of question that is delivered as part of the daily check-ins
                    </div>
                    <div class="flex-center">
                      <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedQuestionType">
                    <el-dropdown-item v-for="item in questionTypeOption" :key="item.type">
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                        }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearQuestionTypeSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                    }}</el-button>
                  <el-button @click="saveQuestionTypeFiltered" type="save">{{
                    $t("powerUp.Okay")
                    }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-if="questionFilterList.length > 0" class="relative" style="width: 26px">
              <div @click="checkedQuestionType = [], saveQuestionTypeFiltered()" class="drop-down-close">
                <div class="x-btn">
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center drop-down-container" :class="`${dimensionFilterList.length > 0 ? 'active' : ''}`">
            <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownDimension">
              <div class="text-drop-down flex-mid">
                <span v-if="dimensionFilterList.length > 0">
                  ({{ dimensionFilterList.length }})&nbsp;
                </span>
                <div>Dimension</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button @click="handleSelectAllDimension" class="dropdownHeaderTextStyle" type="text">{{
                      $t("powerUp.Select_all") }}</el-button>
                    <el-button @click="checkedDimension = []" class="dropdownHeaderTextStyle" style="margin-left: 24px"
                      type="text">{{ $t("powerUp.Clear") }}</el-button>
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the dimension of question that is delivered as part of the daily check-ins
                    </div>
                    <div class="flex-center">
                      <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedDimension">
                    <el-dropdown-item v-for="item in dimensionOption" :key="item.type">
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                        }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearDimensionSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                    }}</el-button>
                  <el-button @click="saveDimensionFiltered" type="save">{{
                    $t("powerUp.Okay")
                    }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-if="dimensionFilterList.length > 0" class="relative" style="width: 26px">
              <div @click="checkedDimension = [], saveDimensionFiltered()" class="drop-down-close">
                <div class="x-btn">
                </div>
              </div>
            </div>
          </div>
          <div class="flex-center drop-down-container" :class="`${arrPowerSkillCheck.length > 0 ? 'active' : ''}`">
            <el-dropdown trigger="click" :hide-on-click="false" ref="dropdownPowerSkillMenu">
              <div class="text-drop-down flex-mid">
                <span v-if="arrPowerSkillCheck.length > 0">
                  ({{ arrPowerSkillCheck.length }})&nbsp;
                </span>
                <div>Power Skill</div>
                <div class="arrow ml-8">
                  <i class="el-icon-arrow-down"></i>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown">
                <div class="dropdownHeader">
                  <div>
                    <el-button @click="handleSelectAllPowerSkill" class="dropdownHeaderTextStyle" type="text">{{
                      $t("powerUp.Select_all") }}</el-button>
                    <el-button @click="checkedArrPowerSkillCheck = []" class="dropdownHeaderTextStyle"
                      style="margin-left: 24px" type="text">{{ $t("powerUp.Clear") }}</el-button>
                  </div>
                  <el-tooltip effect="dark" placement="top">
                    <div class="tooltipStyle" slot="content">
                      Filter by the power skill that a question is designed to practice and develop
                    </div>
                    <div class="flex-center">
                      <img :src="$utils('icons', 'ic_help_outline-16px')" alt="icons_ic_help_outline-16px" />
                    </div>
                  </el-tooltip>
                </div>
                <div class="dropdownItem-tabActivity thin-scrollbar">
                  <el-checkbox-group v-model="checkedArrPowerSkillCheck">
                    <el-dropdown-item v-for="item in powerSkillOption" :key="item.type">
                      <el-checkbox :label="item.type" :key="item.type">{{
                        item.type
                        }}</el-checkbox>
                    </el-dropdown-item>
                  </el-checkbox-group>
                </div>
                <div class="dropdownFooter">
                  <el-button @click="clearPowerSkillSelected" type="cancel">{{
                    $t("powerUp.Cancel")
                    }}</el-button>
                  <el-button @click="savePowerSkillFiltered" type="save">{{
                    $t("powerUp.Okay")
                    }}</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <div v-if="arrPowerSkillCheck.length > 0" class="relative" style="width: 26px">
              <div @click="checkedArrPowerSkillCheck = [], savePowerSkillFiltered()" class="drop-down-close">
                <div class="x-btn">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 220px">
          <el-menu class="input-select" mode="horizontal">
            <el-submenu index="0" style="width: 220px">
              <template slot="title">
                <span class="text-dropdown">{{ selectStatus }} ({{
                  countquestion[status] ? countquestion[status] : 0
                  }})</span>
              </template>
              <el-menu-item @click="statusClick('Active')" index="1" style="font-size: 14px; width: 220px">{{
                $t("questions.Active")
                }} ({{
                  countquestion.N
                    ? $utils("addCommasInNumber", countquestion.N)
                    : 0
                }})</el-menu-item>
              <el-menu-item @click="statusClick('Inactive')" index="2" style="font-size: 14px; width: 220px">{{
                $t("questions.Inactive") }} ({{
                  countquestion.Y ? countquestion.Y : 0
                }})</el-menu-item>
              <el-menu-item @click="statusClick('Show All')" index="3" style="font-size: 14px; width: 220px">{{
                $t("questions.Show_All") }} ({{
                  countquestion.all
                    ? $utils("addCommasInNumber", countquestion.all)
                    : 0
                }})</el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="line-style mt-32" />
      <div>
        <el-table :data="questions" :cell-style="{ padding: '6px 0' }" fixed :empty-text="$utils('placeholderInTable', {
          loadingLoop: loadingQuestionsTable,
          table: questions.length,
          textLoading: ' ',
          textEmpty: 'Loading questions...',
          textNotFound: 'Loading questions...',
        })
          " ref="table" style="width: 100%" @sort-change="handleSortChange">
          <el-table-column class="headerCenter" :label="$t('questions.Status')" prop="block" width="100" min-width="50"
            align="center" sortable>
            <template slot-scope="scope">
              <el-switch @change="handleSpecialBlock(scope.row)" v-model="scope.row.block_status" 
                :active-color="scope.row.notblock ? '#8e44ad' : '#13ce66'"
                inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
          <el-table-column :label="$t('questions.Question')" prop="question_en" width="420">
            <template slot-scope="scope">
              <!-- Remove direct console.log and use method -->
              <div style="line-height: 16px" @mounted="logRowData(scope.row)">
                <div class="fw-700 fs-14" style="color: #000000; word-break: normal; line-height: 18px;">
                  {{ scope.row.question_en }}
                </div>
                <div class="fw-400 fs-14 opa-08 mt-4">
                  <span style="color: #000">{{ scope.row.type_name }} {{ scope.row.power_skill }}</span>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="Dimension" prop="category_name" width="130" sortable>
            <template slot-scope="scope">
              <div style="line-height: 14px">
                <div>
                  <span class="fs-14" style="color: #000000">{{ scope.row.category_name }}</span>
                </div>
                <div class="fs-14 opa-04 mt-6">{{ scope.row.frequency }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="next_occurrence" label="Next" min-width="120" sortable="custom">
            <template slot-scope="scope">
              {{ getNextOccurrence(scope.row) || '-' }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('questions.Action')" header-align="center" width="110" min-width="65"
            align="center">
            <template slot-scope="scope">
              <el-button v-if="(scope.row.type == 'Multiple Choice' &&
                scope.row.m_choice !== undefined &&
                scope.row.m_choice.th !== undefined &&
                Array.isArray(scope.row.m_choice.th) &&
                scope.row.m_choice.th.length === 2) ||
                scope.row.type == 'Text Area Field' ||
                scope.row.type == 'Multiple Choice(other)' ||
                scope.row.custom_type == 'multiple_choice' ||
                scope.row.type == 'Scale'
              " class="btnActionView fs-15 btn-gray-outline" @click="openModal(scope.row)">{{ $t("questions.View")
                }}</el-button>
              <el-button v-else disabled style="background: #f4f4f5">{{
                $t("questions.View")
                }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="loadingQuestions" class="center mb-40 pb-40 relative" style="margin-top: -60px; z-index: 99">
          <div v-for="value in [1, 2, 3, 4]" :key="'custom_mock_question_' + value" :class="{
            'opa-02': value == 4,
            'opa-04': value == 3,
            'opa-06': value == 2,
          }" class="flex-center" style="height: 58px">
            <div class="flex-mid opa-06" style="width: 100px">
              <el-switch active-color="#ccc" inactive-color="#ccc" v-model="mockSwitch"></el-switch>
            </div>
            <div class="mr-auto">
              <div class="text-skeleton fs-18" style="width: 260px">&nbsp;</div>
              <div class="text-skeleton fs-16 opa-06 mt-8" style="width: 100px">
                &nbsp;
              </div>
            </div>
            <div class="flex-center" style="width: 130px">
              <div class="text-skeleton fs-16 ml-12" style="width: 80px">
                &nbsp;
              </div>
            </div>
            <div class="flex-mid opa-02" style="width: 220px">
              <el-button class="btnActionView btn-gray-outline">
                <div class="fs-15" style="width: 24px">&nbsp;</div>
              </el-button>
              <el-button class="btnActionView btn-gray-outline">
                <div class="fs-15" style="width: 24px">&nbsp;</div>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog class="txtHeaderModal" width="960px" :visible.sync="dialogOpenEnded" top="7vh">
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
              }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
              }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.open_ended")
              }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button type="text" @click="downloadExcel_Open_ended()" :disabled="loading">
            <div class="flex-mid">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export">
                <path fill="currentColor"
                  d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
              </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div style="margin-top: 12px">
        <el-table id="openEndedTable" v-loading="loading" :data="dataopenend" :cell-style="{ padding: '6px 0px' }"
          :empty-text="loading ? ' ' : 'No responses available'" height="520">
          <el-table-column :render-header="renderHeaderOpenEnded">
            <template slot-scope="scope">
              <!-- <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingFeedbackAI">
                <loading-even></loading-even>
              </div> -->
              <div v-if="scope.row.Summary" class="summaryLayout">
                <div class="pt-16">
                  <span class="txtHeaderSummary">Summary
                  </span>
                </div>
                <div class="divAllSummary pb-12">
                  <span class="txtAllSummary" :style="$utils('fontStyle', scope.row.Summary)">{{ scope.row.Summary }}
                  </span>
                </div>
                <div style="margin-bottom: 8px; max-height: 164px; flex-wrap: wrap" class="flex divAllSummary">
                  <div class="talkingPointsBox"
                    v-for="(item, index) in scope.row.response_talking_points_show.slice(0, 20)" :key="index">
                    <el-tooltip effect="light" placement="top" class="custom-tooltip">
                      <div class="tooltipStyleTalkingPoints" slot="content">
                        <span class="fs-13 fw-700">{{ item.point.title }}</span>
                        <div v-if="item.point && item.point.specific_examples">
                          <div class="tooltip-items"
                            v-for="(item_specific, index_specific) in item.point.specific_examples"
                            :key="index + '_' + index_specific">
                            <div class="tooltip-item">
                              <div class="oi-circle">
                                <span class="fs-11">{{ index_specific + 1 }}</span>
                              </div>
                              <p>
                                {{ item_specific }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <el-tag :class="`talking-points ${item.sentiment == 'positive'
                        ? 'GreenBoxStyle'
                        : item.sentiment == 'negative'
                          ? 'RedBoxStyle'
                          : 'GreyBoxStyle'
                        }`" v-bind:style="'margin-bottom: 8px;' +
                          $utils('fontStyle', item.point.title)
                          ">{{ truncateText(item.point.title) }}</el-tag>
                    </el-tooltip>
                  </div>
                </div>
                <div class="divAllSummary pb-16">
                  <span class="txtRepeats">AI-generated from feedback shared within 3 months of the selected date
                  </span>
                </div>
              </div>
              <div v-else style="
                  padding: 24px 0;
                  background: rgba(0, 0, 0, 0.03);
                  align-items: center;
                  display: flex;
                ">
                <span class="txtResponse" :style="$utils('fontStyle', scope.row)">{{ scope.row }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog class="txtHeaderModal" width="960px" :visible.sync="dialogYesNo" top="7vh">
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
              }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
              }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{ $t("questions.Yes_or_No") }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button type="text" @click="downloadExcel_YesorNO()" :disabled="loading">
            <div class="flex-mid">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export">
                <path fill="currentColor"
                  d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
              </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table id="yesNoTable" v-loading="loading" :data="datalist" :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" ref="yesNoTable" style="width: 100%"
          height="520">
          <el-table-tree-column file-icon="icon icon-folder" folder-icon="icon icon-folder" :allRemote="true"
            expandKey="extended" row-key="id" child-key="children" width="52" height="50"></el-table-tree-column>

          <el-table-column :render-header="renderHeaderYesNo">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0;">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam"
                    :class="[ blurMode ?  'blurelement': '' ]" 
                    :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div v-if="scope.row.id" class="ml-20">
                  <div class="flex" style="width: 577px; border-radius: 4px; overflow: hidden">
                    <div :class="!yes ? 'bar-results color-4' : 'bar-results color-2'" v-if="scope.row.id"
                      :style="`${getColorPercent(getNoPercent(scope.row.id))}`">
                      <span v-if="getNoPercent(scope.row.id) > 5">{{ getNoPercent(scope.row.id) }}%</span>
                    </div>
                    <div v-if="scope.row.id" :class="yes ? 'bar-results color-4' : 'bar-results color-2'"
                      :style="`${getColorPercent(getYesPercent(scope.row.id))}`">
                      <span v-if="getYesPercent(scope.row.id) > 5">{{ getYesPercent(scope.row.id) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog class="txtHeaderModal" width="960px" :visible.sync="dialogScale" top="7vh">
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
              }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
              }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{ $t("questions.Scale") }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button type="text" @click="downloadExcel_Scale()" :disabled="loading">
            <div class="flex-mid">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export">
                <path fill="currentColor"
                  d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
              </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table id="scaleTable" v-loading="loading" :data="datalist" :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'" ref="scaleTable" style="width: 100%" height="520">
          <el-table-tree-column file-icon="icon icon-folder" folder-icon="icon icon-folder" :allRemote="true"
            expandKey="extended" child-key="children" width="52" height="50"></el-table-tree-column>

          <el-table-column :render-header="renderHeaderScale">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0;">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam" 
                    :class="[ blurMode ?  'blurelement': '' ]"
                    :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div style="width: 40px" class="ml-16 fs-14 fw-700 fc-000000 opa-07 flex-mid">
                  <div v-if="scope.row.id && datamultichoices[scope.row.id]" class="ml-auto">
                    {{ datamultichoices[scope.row.id].avg }}
                  </div>
                </div>
                <div v-if="scope.row.id && datamultichoices[scope.row.id]" style="margin-left: 12px">
                  <div class="flex" :style="`width: 537px; border-radius: 4px; overflow: hidden`">
                    <div v-for="(item, index) in datamultichoices[scope.row.id].range" :key="index"
                      :class="`bar-results color-` + getScaleColor(index)"
                      :style="`${getColorPercentForScale(getScalePercent(scope.row.id, index))}`">
                      <span v-if="getScalePercent(scope.row.id, index) > 5">
                        {{ getScalePercent(scope.row.id, index) }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog class="txtHeaderModal" width="960px" :visible.sync="dialogMultipleOther" top="7vh">
      <div class="flex">
        <div>
          <div class="ml-20">
            <span class="fw-700 fs-20 fc-000000">{{
              $t("questions.QUESTION_DETAILS")
              }}</span>
          </div>
          <div class="ml-20 mt-24">
            <span class="fw-700 fs-18 fc-000000 word-break">{{
              quest_name
              }}</span>
          </div>
          <div class="ml-20 mt-4">
            <span class="fc-626262 fs-14">{{
              $t("questions.Multiple_Choice")
              }}</span>
          </div>
        </div>
        <div class="ml-auto" style="padding-top: 35px">
          <el-button type="text" @click="downloadExcel_MultipleChoice()" :disabled="loading">
            <div class="flex-mid">
              <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon-export">
                <path fill="currentColor"
                  d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z" />
              </svg>
              <div style="color: #000000">{{ $t("global.DOWNLOAD") }}</div>
            </div>
          </el-button>
        </div>
      </div>
      <div class="shadowBottom" />

      <div class="mt-12">
        <el-table id="otherTable" v-loading="loading" :data="datalist" :cell-style="{ padding: '0' }"
          :empty-text="loading ? ' ' : 'No responses available'" ref="otherTable" style="width: 100%" height="520">
          <el-table-tree-column file-icon="icon icon-folder" folder-icon="icon icon-folder" :allRemote="true"
            expandKey="extended" child-key="children" width="52" height="50"></el-table-tree-column>

          <el-table-column :render-header="renderHeaderMultipleOther">
            <template slot-scope="scope">
              <div style="flex-direction: row; display: flex; margin: 5px 0;">
                <div class="rowItem flex-center">
                  <div class="flex-column">
                    <span class="txtTeam" 
                    :class="[ blurMode ?  'blurelement': '' ]"
                    :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ scope.row.team }}
                    </span>
                    <span v-if="scope.row.id && datamultichoices[scope.row.id]"
                      class="fs-12 fw-400 fc-626262 opa-06 lh-14"
                      :style="{ marginLeft: `${16 + (scope.row.depth * 16)}px` }">
                      {{ getTotalResponses(scope.row.id) }} responses
                    </span>
                  </div>
                </div>
                <div v-if="scope.row.id" class="ml-20">
                  <div class="flex" style="width: 577px; border-radius: 4px; overflow: hidden;">
                    <div v-for="(item, index) in datamultichoices[scope.row.id]" :key="index"
                      :style="`width: ${getMultipleChoicePercent(scope.row.id, index)}%`">
                      <div v-if="getMultipleChoicePercent(scope.row.id, index) > 6"
                        :class="`bar-results color-` + getMultipleChoiceColor(index)" :style="`width: 100%;`">
                        <span>{{ getMultipleChoicePercent(scope.row.id, index) }}%</span>
                      </div>
                      <el-tooltip v-else-if="getMultipleChoicePercent(scope.row.id, index)"
                        :content="`${getMultipleChoicePercent(scope.row.id, index)}%`" placement="top">
                        <div :class="`bar-results color-` + getMultipleChoiceColor(index)" :style="`width: 100%;`">
                          &nbsp;
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import format from "date-fns/format";
import { cpus } from "os";
export default {
  name: "standard",
  components: {
    loadingEven: require("../even/loading").default,
  },
  created() {
    this.$store.dispatch("question/getTeamHeight", this.user);

    // this.$store.dispatch("teams/getTeamArr", this.user);
    // this.$store.dispatch("teams/getOrganization");
    // this.$store.dispatch("team/getTeamsOptions", this.user);
    // this.$store.dispatch("teams/getInsightTeamsByComp");
    // this.$store.commit("teams/setTeam", "all");
    this.$store.dispatch("question/getQuestions", this.user);
    this.$store.dispatch("question/getDataOrganize", this.user);
    this.$store.commit("authen/setActiveIndex", "4");
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["question/inputSearch"];
      },
      set(value) {
        this.$store.commit("question/setinputSearch", { value });
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    questions() {
      this.loadingQuestionsTable = ++this.loadingQuestionsTable;
      return this.$store.getters["question/questions"];
    },
    loadingQuestions() {
      return this.$store.getters["question/questionLoading"];
    },
    countquestion() {
      return this.$store.getters["question/countquestion"];
    },
    datalist() {
      return this.$store.getters["question/datalist"];
    },
    dateoptions() {
      return this.$store.getters["question/dateoptions"];
    },
    dataopenend() {
      return this.$store.getters["question/dataopenend"];
    },
    datamultichoices() {
      return this.$store.getters["question/datamultichoices"];
    },
    countmultichoices() {
      return this.$store.getters["question/countmultichoices"];
    },
    loading() {
      return this.$store.getters["question/loading"];
    },
    dateShow() {
      return this.$store.getters["question/dateShow"];
    },
    teamArr() {
      return this.$store.getters["question/teamArr"];
    },
    teamAll() {
      return this.$store.getters["question/teamAll"];
    },
    organizations() {
      return this.$store.getters["question/organizations"];
    },
    answerOpt() {
      return this.$store.getters["question/answerOpt"];
    },
    openModalDashboard() {
      return this.$store.getters["dashboard/openModalDashboard"];
    },
    questionOpenEnd() {
      return this.$store.getters["dashboard/questionOpenEnd"];
    },
    dimensionOption() {
      return this.$store.getters["question/dimensionOption"];
    },
    deletedTeam() {
      return this.$store.getters["question/deletedTeam"];
    },
    teamHeight() {
      return this.$store.getters["question/teamHeight"];
    },
    loadingFeedbackAI() {
      return this.$store.getters["question/loadingFeedbackAI"];
    },
    summaryDetail() {
      return this.$store.getters["question/summaryDetail"];
    },
    _organization1level() {
      return this.$store.getters["question/organization1level"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("question/searchQuestions", this.inputSearch);
    },
  },
  data() {
    return {
      activeIndex: "1",
      mockSwitch: false,
      id: "",
      mode: "",
      parent_id: "",
      selectStatus: "Show All",
      width: "",
      status: "all",
      status_value: true,
      dialogOpenEnded: false,
      dialogYesNo: false,
      dialogScale: false,
      dialogMultipleOther: false,
      quest_id: null,
      quest_name: null,
      quest_multiple_choice_3: true,
      quest_choice_3_value: {
        color_1: 23,
        color_2: 20,
        color_3: 7,
        color_4: 5,
        color_5: 15,
        color_6: 30,
      },
      yes: true,
      loadingQuestionsTable: -1,
      organization1level: [],
      questionTypeOption: [
        { type: "Multiple Choice" },
        { type: "Scale" },
        { type: "Open-ended" },
        { type: "Yes/No" },
        { type: "Follow-up" },
      ],
      checkedQuestionType: [],
      questionFilterList: [],
      // dimensionOption: [
      //   { type: "A" },
      //   { type: "B" },
      // ],
      checkedDimension: [],
      dimensionFilterList: [],
      powerSkillOption: [
        { type: "Empathy" },
        { type: "Optimism" },
        { type: "Self Awareness" },
        { type: "Initiative Making" },
        { type: "Leadership" },
        { type: "Critical Thinking" },
      ],
      checkedArrPowerSkillCheck: [],
      arrPowerSkillCheck: [],
    };
  },
  mounted() {
    // this.width = Math.round(this.$refs.table.$el.clientWidth / 4);
    const questionID = this.$router.currentRoute.query.questionID;
    if (questionID && this.openModalDashboard == true) {
      this.autoOpenModalByQuery(questionID);
    }
  },
  methods: {
    truncateText(text) {
      let length = this.maxLength;
      return text.length > length ? text.slice(0, length) + "..." : text;
    },
    getScalePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        for (var i = 0; i < this.datamultichoices[id]["range"].length; i++) {
          total += this.datamultichoices[id]["range"][i];
        }
        if (total !== 0) {
          let results = Math.round(
            (this.datamultichoices[id]["range"][index] * 100) / total
          );
          return results;
        } else {
          return 0;
        }
      }
    },
    getColorPercentForScale(value) {
      if (value) {
        return `width: ${Math.round((537 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    getYesPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][0] * 100) / total);
        else return 0;
      }
    },
    getNoPercent(id) {
      if (this.datamultichoices[id]) {
        const total =
          this.datamultichoices[id][0] + this.datamultichoices[id][1];
        if (total !== 0)
          return Math.round((this.datamultichoices[id][1] * 100) / total);
        else return 0;
      }
    },
    getMultipleChoicePercent(id, index) {
      if (this.datamultichoices[id]) {
        let total = 0;
        if (this.answerOpt.length > 0) {
          for (var i = 0; i < this.datamultichoices[id].length; i++) {
            total += this.datamultichoices[id][i];
          }
          if (total !== 0) {
            let results = Math.round(
              (this.datamultichoices[id][index] * 100) / total
            );
            return results;
          } else {
            return 0;
          }
        }
      }
    },
    getColorPercent(value) {
      if (value) {
        return `width: ${Math.round((577 / 100) * value)}px;`;
      } else {
        return;
      }
    },
    autoOpenModalByQuery(id) {
      if (id) {
        this.$store.commit("dashboard/setOpenModalDashboard", false);
        this.openModal(this.questionOpenEnd);
      } else {
        this.$message({
          showClose: true,
          message: "Soory, Question not found :(",
          type: "error",
          duration: 4000,
        });
      }
    },
    openModal(elm) {
      this.quest_id = elm.key;
      this.quest_name = elm.question_en;
      this.$store.commit("question/setLoading", true);
      if (elm.type === "Multiple Choice") {
        if (elm.custom_type === "multiple_choice") {
          this.$store.commit("question/setCountMultiChoices", 0);
          this.$store.commit("question/setDataMultiChoices", []);
          this.dialogMultipleOther = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
            custom_type: elm.custom_type,
          });
        } else {
          if (elm.m_choice.weight[0] === "0") {
            this.yes = false;
          } else {
            this.yes = true;
          }
          this.$store.commit("question/setDataMultiChoices", []);
          this.$store.commit("question/setCountMultiChoices", 0);
          this.dialogYesNo = true;
          this.$store.dispatch("question/getDateDetail", {
            quest_id: elm.key,
            type: elm.type,
          });
        }
      } else if (elm.type === "Scale") {
        this.$store.commit("question/setCountMultiChoices", 0);
        this.$store.commit("question/setDataMultiChoices", []);
        this.dialogScale = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
        });
      } else {
        this.$store.commit("question/setDataOpenEnd", []);
        this.dialogOpenEnded = true;
        this.$store.dispatch("question/getDateDetail", {
          quest_id: elm.key,
          type: elm.type,
        });
      }
    },
    handleBlock(item) {
      if (item.block_status === false) {
        this.$store.dispatch("question/blockQuestion", item.key);
      } else {
        this.$store.dispatch("question/unblockQuestion", item.key);
      }
    },
    handleSpecialBlock(item) {
      if (item.notblock && !item.block_status) {
        // If the toggle is being turned OFF (block_status is now false)
        // Immediately revert the toggle until user confirms
        item.block_status = true;
        
        // Show confirmation dialog for essential questions
        this.$confirm(
          'This question is an essential baseline question. Disabling it will impact the reports and insights significantly. Are you sure you want to proceed?',
          'Warning',
          {
            confirmButtonText: 'Yes, proceed',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          // User confirmed, proceed with toggle
          item.block_status = false;  // Set it to false manually
          this.handleBlock(item);
        }).catch(() => {
          // User cancelled, toggle already reverted above
        });
      } else {
        // Regular question or enabling a special question, proceed normally
        this.handleBlock(item);
      }
    },
    statusClick(type) {
      const opt = [];
      opt["Active"] = "N";
      opt["Inactive"] = "Y";
      opt["Show All"] = "all";
      this.selectStatus = type;
      this.status = opt[type];
      this.$store.commit("question/setselectShow", { type: opt[type] });
      this.$store.dispatch("question/selectStatus", this.status);
    },
    handleDateCommand(date) {
      if (date) {
        for (const x in this.dateoptions) {
          if (this.dateoptions[x].date === date) {
            this.$store.commit(
              "question/setDateShow",
              this.dateoptions[x]["show"]
            );
          }
        }
      }
      this.$store.commit("question/setLoading", true);
      if (this.dialogYesNo) {
        this.$store.dispatch("question/getDataMultiChoices", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogMultipleOther) {
        this.$store.dispatch("question/getDataMultiChoicesOther", {
          date,
          quest_id: this.quest_id,
        });
      } else if (this.dialogScale) {
        this.$store.dispatch("question/getDataScale", {
          date,
          quest_id: this.quest_id,
        });
      } else {
        this.$store.dispatch("question/getDataOpenEnd", {
          date,
          quest_id: this.quest_id,
        });
      }
    },
    renderDropdown() {
      if (this.dateoptions.length > 1) {
        return (
          <i
            style="margin-left: 16px; color: #000000;"
            class="el-icon-arrow-down"
          ></i>
        );
      }
    },
    renderHeaderOpenEnded(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      let countMessage = this.dataopenend.length;
      if (countMessage && countMessage > 0 && this.summaryDetail.Summary) {
        countMessage = countMessage - 1
      }
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div class="headerOpenEnded">
          <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
            <span class="txtDropdown">
              {this.dateShow}
              {this.renderDropdown()}
            </span>

            <el-dropdown-menu slot="dropdown">
              <div style="max-height: 200px; width: 200px; overflow:auto;">
                {components}
              </div>
            </el-dropdown-menu>
          </el-dropdown>

          <span class="txtTotalResponse">
            {countMessage} {responses}
          </span>
        </div>
      );
    },
    renderHeaderYesNo(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let classForNo = !this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      let classForYes = this.yes ? "box color-4 mr-8" : "box color-2 mr-8";
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              <div class="flex ml-20">
                <div class={classForYes}></div>
                <div>Yes</div>
              </div>
              <div class="flex ml-20">
                <div class={classForNo}></div>
                <div>No</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    getMultipleChoiceColor(index) {
      if (this.answerOpt.length > 0) {
        let orderColor = [];
        if (this.answerOpt.length == 2) {
          orderColor = [2, 4];
        } else if (this.answerOpt.length == 3) {
          orderColor = [2, 3, 4];
        } else if (this.answerOpt.length == 4) {
          orderColor = [2, 3, 4, 5];
        } else {
          let no = 1;
          for (var i = 0; i < this.answerOpt.length; i++) {
            orderColor.push(no);
            no = no + 1;
          }
        }
        return orderColor[index];
      }
    },
    getScaleColor(index) {
      let orderColor = [2, 3, 4];
      return orderColor[index];
    },
    getScaleWidth(id) {
      if (this.datamultichoices[id]) {
        return `width: ${Math.round(
          (537 / 10) * this.datamultichoices[id].avg
        )}px;`;
      }
    },
    renderHeaderScale(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-13 mt-10">
              <div class="flex ml-20">
                <div class="box color-4 mr-8"></div>
                <div class="fc-000000 opa-06">9-10</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-3 mr-8"></div>
                <div class="fc-000000 opa-06">7-8</div>
              </div>
              <div class="flex ml-20">
                <div class="box color-2 mr-8"></div>
                <div class="fc-000000 opa-06">0-6</div>
              </div>
            </div>
          </div>
        </div>
      );
    },
    renderHeaderMultipleOther(creatElement, { column }) {
      let components = [];
      for (var i = 0; i < this.dateoptions.length; i++) {
        components.push(
          <el-dropdown-item command={this.dateoptions[i].date}>
            {this.dateoptions[i]["show"]}
          </el-dropdown-item>
        );
      }
      const countMessage = this.countmultichoices;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      let components_answer = [];
      if (this.answerOpt.length > 0) {
        let orderColor = [];
        if (this.answerOpt.length == 2) {
          orderColor = [4, 2];
        } else if (this.answerOpt.length == 3) {
          orderColor = [4, 3, 2];
        } else if (this.answerOpt.length == 4) {
          orderColor = [5, 4, 3, 2];
        } else {
          let no = this.answerOpt.length;
          for (var i = this.answerOpt.length; i > 0; i--) {
            orderColor.push(no);
            no = no - 1;
          }
        }
        for (var i = 0; i < this.answerOpt.length; i++) {
          components_answer.push(
            <div class="flex ml-20">
              <div class={"box color-" + orderColor[i] + " mr-8"}></div>
              <div>{this.answerOpt[i]}</div>
            </div>
          );
        }
      }
      return (
        <div>
          <div class="flex-between mt-10 mb-2">
            <el-dropdown trigger="click" onCommand={this.handleDateCommand}>
              <span class="txtDropdown">
                {this.dateShow}
                {this.renderDropdown()}
              </span>
              <el-dropdown-menu slot="dropdown">
                <div style="max-height: 200px; width: 200px; overflow:auto;">
                  {components}
                </div>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="txtTotalResponse">
              {this.$utils("addCommasInNumber", countMessage)} {responses}
            </span>
          </div>
          <div>
            <div class="right flex-reverse fs-12 mt-10">
              {components_answer}
            </div>
          </div>
        </div>
      );
    },
    async downloadExcel_Open_ended() {
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";

      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Open-ended";
      ws.getCell("B6").value = this.dateShow;

      let countMessage = this.dataopenend.length;
      if (countMessage && countMessage > 0 && this.summaryDetail.Summary) {
        countMessage = countMessage - 1
      }
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getCell("B7").value = countMessage + " " + responses;
      ws.getCell("B8").value = "";
      ws.getColumn("A").width = 5;
      //   /*Data*/
      _.forEach(this.dataopenend, (item, key) => {
        if (!item.Summary) {
          let _tmp = ["", item];
          ws.addRow(_tmp);
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_opened-ended" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_YesorNO() {
      console.log("downloadExcel_YesorNO", this.teamAll)
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        console.log('value', value)
        let total = 0;
        let resY = 0;
        let resN = 0;
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          console.log('value1111', value.parent)
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          total =
            this.datamultichoices[value.key][0] +
            this.datamultichoices[value.key][1];
          resY = this.datamultichoices[value.key][0];
          resN = this.datamultichoices[value.key][1];
        }
        team.push({
          ...value,
          parent_name: parent_name,
          percentYes: this.getYesPercent(value.key),
          percentNo: this.getNoPercent(value.key),
          resY: resY,
          resN: resN,
          total_res: total,
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1;
        for (const keyId in this.deletedTeam) {
          let total = 0;
          let resY = 0;
          let resN = 0;
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            total =
              this.datamultichoices[keyId][0] +
              this.datamultichoices[keyId][1];
            resY = this.datamultichoices[keyId][0];
            resN = this.datamultichoices[keyId][1];
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            percentYes: this.getYesPercent(keyId),
            percentNo: this.getNoPercent(keyId),
            resY: resY,
            resN: resN,
            total_res: total,
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;

      let teams = ''
      if (this.user.user_type == 'leadership') {
        teams = organizations[this.user.team];
      } else {
        teams = organizations[level0[0] ? level0[0].key : ''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
            // dispatch('getTeamOfParent', value.parent)
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if (this.user.user_type == 'leadership') {
            if (this._organization1level[this.user.team][keyId2]) {
              organization1level[keyId2] = true;
            }

          } else {
            organization1level[keyId2] = true;
          }

        }
      }

      _.forEach(organization1level, (value, team_id) => {
        console.log('team', team_id)
        let _temp = _.find(team, ["key", team_id]);

        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Yes/No";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        let _tmp = [
          "",
          item.name,
          item.parent_name,
          "Yes",
          item.percentYes,
          item.resY,
          item.total_res,
        ];
        ws.addRow(_tmp);
        let _tmp1 = ["", "", "", "No", item.percentNo, item.resN];
        ws.addRow(_tmp1);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Yes-No" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async getTeamOfParent(item) {
      const organization1level = this.organization1level;
      _.forEach(item, (value) => {
        organization1level[value.team_id] = true;
        if (value.parent) {
          this.getTeamOfParent(value.parent);
          console.log('value.parent', value.parent)
          // dispatch('getTeamOfParent', value.parent)
        }
      });
    },
    async downloadExcel_MultipleChoice() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let option = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (var i = 0; i < this.datamultichoices[value.key].length; i++) {
            total += this.datamultichoices[value.key][i];
            option[`precent${i + 1}`] = this.getMultipleChoicePercent(value.key, this.answerOpt.length - i - 1);
            option[`res${i + 1}`] = this.datamultichoices[value.key][this.answerOpt.length - i - 1];
            option[`options${i + 1}`] = this.answerOpt[i];
            option['optionCount'] = option['optionCount'] ? option['optionCount'] + 1 : 1
          }
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          ...option,
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1
        for (const keyId in this.deletedTeam) {
          this.teamAll.map((value) => {
            let total = 0;
            let option = {};
            let parent_name =
              this.teamArr[this.teamHeight] !== undefined
                ? this.teamArr[this.teamHeight].name
                : "noun";
            if (this.datamultichoices[keyId]) {
              for (var i = 0; i < this.datamultichoices[keyId].length; i++) {
                total += this.datamultichoices[keyId][i];
                option[`precent${i + 1}`] = this.getMultipleChoicePercent(keyId, this.answerOpt.length - i - 1);
                option[`res${i + 1}`] = this.datamultichoices[keyId][this.answerOpt.length - i - 1];
                option[`options${i + 1}`] = this.answerOpt[i];
                option['optionCount'] = option['optionCount'] ? option['optionCount'] + 1 : 1
              }
            }
            team.push({
              key: keyId,
              name: 'Deleted Team ' + index,
              parent: this.teamHeight,
              parent_name: parent_name,
              total_res: total,
              ...option,
            });
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      let teams = ''
      if (this.user.user_type == 'leadership') {
        teams = organizations[this.user.team];
      } else {
        teams = organizations[level0[0] ? level0[0].key : ''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if (this.user.user_type == 'leadership') {
            if (this._organization1level[this.user.team][keyId2]) {
              organization1level[keyId2] = true;
            }

          } else {
            organization1level[keyId2] = true;
          }
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Multiple Choice";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Option",
        "Value",
        "Responses",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        if (item.optionCount && item.optionCount > 0) {
          for (var i = 0; i < item.optionCount; i++) {
            if (i == 0) {
              let _tmp = [
                "",
                item.name,
                item.parent_name,
                item.options1,
                item.percent1,
                item.res1,
                item.total_res,
              ];
              ws.addRow(_tmp);
            } else {
              let _tmp1 = ['', '', '', item[`options${i + 1}`], item[`options${i + 1}`], item[`res${i + 1}`]];
              ws.addRow(_tmp1);
            }
          }
        } else {
          let _tmp = [
            "",
            item.name,
            item.parent_name,
            item.options1,
            item.percent1,
            item.res1,
            item.total_res,
          ];
          ws.addRow(_tmp);
          ws.addRow();
        }
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Multiple-Choice" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    async downloadExcel_Scale() {
      var team = [];
      var level0 = [];
      var data = [];
      this.teamAll.map((value) => {
        let total = 0;
        let avg = {};
        let parent_name =
          this.teamArr[value.parent] !== undefined
            ? this.teamArr[value.parent].name
            : "noun";
        if (this.teamArr[value.parent] === undefined) {
          level0.push(value);
        }
        if (this.datamultichoices[value.key]) {
          for (
            var i = 0;
            i < this.datamultichoices[value.key]["range"].length;
            i++
          ) {
            total += this.datamultichoices[value.key]["range"][i];
          }
          avg = this.datamultichoices[value.key].avg;
        }
        team.push({
          ...value,
          parent_name: parent_name,
          total_res: total,
          avg: avg,
          range0to6: this.getScalePercent(value.key, 0),
          range7to8: this.getScalePercent(value.key, 1),
          range9to10: this.getScalePercent(value.key, 2),
        });
      });
      if (Object.keys(this.deletedTeam).length > 0) {
        let index = 1
        for (const keyId in this.deletedTeam) {
          let total = 0;
          let avg = {};
          let parent_name =
            this.teamArr[this.teamHeight] !== undefined
              ? this.teamArr[this.teamHeight].name
              : "noun";
          if (this.datamultichoices[keyId]) {
            for (
              var i = 0;
              i < this.datamultichoices[keyId]["range"].length;
              i++
            ) {
              total += this.datamultichoices[keyId]["range"][i];
            }
            avg = this.datamultichoices[keyId].avg;
          }
          team.push({
            key: keyId,
            name: 'Deleted Team ' + index,
            parent: this.teamHeight,
            parent_name: parent_name,
            total_res: total,
            avg: avg,
            range0to6: this.getScalePercent(keyId, 0),
            range7to8: this.getScalePercent(keyId, 1),
            range9to10: this.getScalePercent(keyId, 2),
          });
          index++
        }
      }
      const organizations = this.organizations;
      this.organization1level = {};
      const organization1level = this.organization1level;
      let teams = ''
      if (this.user.user_type == 'leadership') {
        teams = organizations[this.user.team];
      } else {
        teams = organizations[level0[0] ? level0[0].key : ''];
      }
      if (teams) {
        organization1level[teams.team_id] = true;
        _.forEach(teams.parent, (value) => {
          organization1level[value.team_id] = true;
          if (value.parent) {
            this.getTeamOfParent(value.parent);
          }
        });
      } else {
        organization1level[level0[0].key] = true;
      }
      if (Object.keys(this.deletedTeam).length > 0) {
        for (const keyId2 in this.deletedTeam) {
          if (this.user.user_type == 'leadership') {
            if (this._organization1level[this.user.team][keyId2]) {
              organization1level[keyId2] = true;
            }

          } else {
            organization1level[keyId2] = true;
          }
        }
      }
      _.forEach(organization1level, (value, team_id) => {
        let _temp = _.find(team, ["key", team_id]);
        data.push(_temp);
      });
      var date_data = format(this.dateShow, "YYYYMMDD");
      var question = "";
      this.quest_name
        .trim()
        .split(" ")
        .map((value, i) => {
          if (i < 5) {
            question = question + "_" + value;
          }
        });
      this.exportActivityStatus = true;
      this.dialogExport = false;
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      /*TITLE*/
      ws.mergeCells("B2", "C2", "D2", "E2");
      ws.getRow(2).height = 25;
      ws.getCell("B2").font = { name: "Arial", size: 18, bold: true };
      ws.getCell("B2").alignment = { vertical: "middle" };

      ws.getCell("B2").value = "QUESTION DETAILS";
      ws.getCell("B3").value = this.quest_name;
      ws.getCell("B4").value = "Scale";
      ws.getCell("B6").value = this.dateShow;

      const countMessage = this.dataopenend.length;
      let responses = "response";
      if (countMessage > 1) {
        responses = "responses";
      }
      ws.getColumn("A").width = 5;
      let header = [
        "",
        "Team Name",
        "Parent Team",
        "Average Rating",
        "0-6 (%)",
        "7-8 (%)",
        "	9-10 (%)",
        "Total Responses",
      ];
      ws.getRow(7).values = header;
      //   /*Data*/
      _.forEach(data, (item, key) => {
        let _tmp = [
          "",
          item.name,
          item.parent_name,
          item.avg,
          item.range0to6,
          item.range7to8,
          item.range9to10,
          item.total_res,
        ];
        ws.addRow(_tmp);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = date_data + "_Scale" + question + ".xlsx";
          document.body.appendChild(a);
          a.click();
          /*save logs*/
          this.$store.dispatch(
            "authen/addLogs",
            {
              company: this.user.company,
              createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
              table: "questions",
              status: "downloaded",
              user: this.user.email,
            },
            { root: true }
          );
        })
        .catch(function (error) {
          console.log(error.message);
        });
      this.exportActivityStatus = false;
    },
    handleSelectAllQuestionType() {
      if (this.checkedQuestionType.length !== this.questionTypeOption.length) {
        let checked = [];
        for (const i in this.questionTypeOption) {
          checked.push(this.questionTypeOption[i].type);
        }
        this.checkedQuestionType = checked;
      }
    },
    clearQuestionTypeSelected() {
      this.checkedQuestionType = this.questionFilterList;
      this.$refs.dropdownValuesMenu.visible = false;
    },
    saveQuestionTypeFiltered() {
      this.questionFilterList = this.checkedQuestionType;
      this.$refs.dropdownValuesMenu.visible = false;
      //console.log(" this.checkedQuestionType", this.checkedQuestionType)
      this.$store.dispatch("question/filtersQuestion", { questionstype: this.checkedQuestionType, powerskill: this.checkedArrPowerSkillCheck, dimension: this.checkedDimension })
      // this.checkedQuestionType = [];
    },
    handleSelectAllDimension() {
      if (this.checkedDimension.length !== this.dimensionOption.length) {
        let checked = [];
        for (const i in this.dimensionOption) {
          checked.push(this.dimensionOption[i].type);
        }
        this.checkedDimension = checked;
      }
    },
    clearDimensionSelected() {
      this.checkedDimension = this.dimensionFilterList;
      this.$refs.dropdownDimension.visible = false;
    },
    saveDimensionFiltered() {
      this.dimensionFilterList = this.checkedDimension;
      this.$refs.dropdownDimension.visible = false;
      // console.log(" this.checkedDimension", this.checkedDimension)
      this.$store.dispatch("question/filtersQuestion", { questionstype: this.checkedQuestionType, powerskill: this.checkedArrPowerSkillCheck, dimension: this.checkedDimension })
      // this.checkedDimension = [];
    },
    handleSelectAllPowerSkill() {
      if (this.checkedArrPowerSkillCheck.length !== this.powerSkillOption.length) {
        let checked = [];
        for (const i in this.powerSkillOption) {
          checked.push(this.powerSkillOption[i].type);
        }
        this.checkedArrPowerSkillCheck = checked;
      }
    },
    clearPowerSkillSelected() {
      this.checkedArrPowerSkillCheck = this.arrPowerSkillCheck;
      this.$refs.dropdownPowerSkillMenu.visible = false;
    },
    savePowerSkillFiltered() {
      this.arrPowerSkillCheck = this.checkedArrPowerSkillCheck;
      this.$refs.dropdownPowerSkillMenu.visible = false;
      //console.log("this.checkedArrPowerSkillCheck;",this.checkedArrPowerSkillCheck)
      this.$store.dispatch("question/filtersQuestion", { questionstype: this.checkedQuestionType, powerskill: this.checkedArrPowerSkillCheck, dimension: this.checkedDimension })
      // this.checkedArrPowerSkillCheck = [];
    },
    getTotalResponses(id) {
      if (!this.datamultichoices[id]) return 0;

      // For Scale type (has 'range' property)
      if (this.datamultichoices[id].range) {
        return this.datamultichoices[id].range.reduce((sum, current) => sum + current, 0);
      }

      // For Yes/No type (array with 2 values)
      if (Array.isArray(this.datamultichoices[id]) && this.datamultichoices[id].length === 2) {
        return this.datamultichoices[id][0] + this.datamultichoices[id][1];
      }

      // For Multiple Choice (array with multiple values)
      if (Array.isArray(this.datamultichoices[id])) {
        return this.datamultichoices[id].reduce((sum, current) => sum + current, 0);
      }

      return 0;
    },
    logRowData(row) {
      console.log('Question row data:', {
        id: row.key,
        question: row.question,
        type: row.type,
        repeats: row.repeats,
        nextOccurrence: this.getNextOccurrence(row)
      });
    },
    getNextOccurrence(row) {
      // For follow-up questions
      if (row.parent !== 'N') {
        return 'Follow-up';
      }

      // For one-time questions
      if (!row.repeats) {
        if (!row.delivery_date) return 'One-time';
        const deliveryDate = new Date(row.delivery_date);
        const today = new Date();
        return deliveryDate < today ? 'Completed' : deliveryDate.toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      // For weekly questions
      if (row.repeats === 'weekly' && row.repeat_days) {
        const today = new Date();
        const currentDay = today.getDay(); // 0-6 (Sunday-Saturday)
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        
        // console.log('Current day:', days[currentDay]); // Debug log
        // console.log('Enabled days:', row.repeat_days); // Debug log

        // Get only the days that are enabled ('Y')
        const enabledDays = days
          .map((day, index) => ({ day, index }))
          .filter(({ day }) => row.repeat_days[day] === 'Y')
          .map(({ index }) => index);

        //console.log('Enabled day indexes:', enabledDays); // Debug log

        if (enabledDays.length === 0) {
          return 'No schedule';
        }

        // Find the next enabled day
        let nextDay = enabledDays.find(day => day > currentDay);
        if (nextDay === undefined) {
          // If no days left this week, get the first enabled day of next week
          nextDay = enabledDays[0];
        }

        //console.log('Next day index:', nextDay); // Debug log

        // Calculate the date
        const nextDate = new Date(today);
        const daysToAdd = nextDay > currentDay ? 
          nextDay - currentDay : 
          7 - currentDay + nextDay;
        
        //console.log('Days to add:', daysToAdd); // Debug log
        
        nextDate.setDate(today.getDate() + daysToAdd);

        //console.log('Next date:', nextDate); // Debug log

        return nextDate.toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      // For daily questions
      if (row.repeats === 'daily') {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        return tomorrow.toLocaleDateString('default', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      }

      const today = new Date();
      const currentWeek = Math.ceil(today.getDate() / 7);
      const currentDay = today.toLocaleDateString('en-US', { weekday: 'short' });
      const currentQuarter = Math.floor((today.getMonth() / 3)) + 1;
      const currentMonth = today.getMonth();

      // Get next scheduled day
      let nextDay = null;
      if (row.repeat_days) {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const currentDayIndex = days.indexOf(currentDay);
        const nextDayIndex = days.findIndex((day, index) =>
          index > currentDayIndex && row.repeat_days[day] === 'Y'
        ) || days.findIndex(day => row.repeat_days[day] === 'Y');

        if (nextDayIndex >= 0) {
          nextDay = days[nextDayIndex];
        }
      }

      // Get next scheduled week
      let nextWeek = null;
      if (row.repeat_weeks) {
        const weeks = ['week1', 'week2', 'week3', 'week4', 'week5'];
        const nextWeekIndex = weeks.findIndex((week, index) =>
          index + 1 >= currentWeek && row.repeat_weeks[week] === 'Y'
        ) || weeks.findIndex(week => row.repeat_weeks[week] === 'Y');

        if (nextWeekIndex >= 0) {
          nextWeek = nextWeekIndex + 1;
        }
      }

      // Get next scheduled quarter
      let nextQuarter = null;
      if (row.repeat_quarters) {
        const quarters = ['Q1', 'Q2', 'Q3', 'Q4'];
        const nextQuarterIndex = quarters.findIndex((q, index) =>
          index + 1 >= currentQuarter && row.repeat_quarters[q] === 'Y'
        ) || quarters.findIndex(q => row.repeat_quarters[q] === 'Y');

        if (nextQuarterIndex >= 0) {
          nextQuarter = nextQuarterIndex + 1;
        }
      }

      // Format the next occurrence message based on repeat type
      switch (row.repeats) {
        case 'biannually':
        case 'quarterly':
          if (nextQuarter) {
            const today = new Date();
            const currentMonth = today.getMonth();
            const currentQuarter = Math.floor(currentMonth / 3) + 1;

            // Get available quarters
            const availableQuarters = Object.entries(row.repeat_quarters)
              .filter(([_, value]) => value === 'Y')
              .map(([quarter]) => parseInt(quarter.substring(1)));

            // Calculate dates for all available quarters in current year
            const possibleDates = availableQuarters.map(quarter => {
              // Always start with current year
              const year = today.getFullYear();
              const quarterStartMonth = (quarter - 1) * 3;
              const targetMonth = quarterStartMonth + (parseInt(row.repeat_quarter) - 1);

              const date = new Date(year, targetMonth, 1);

              // If we have specific week and day settings, use those
              if (row.repeat_weeks && row.repeat_days) {
                const weekEntry = Object.entries(row.repeat_weeks)
                  .find(([_, value]) => value === 'Y');
                const targetWeek = weekEntry ? weekEntry[0] : null;

                const dayEntry = Object.entries(row.repeat_days)
                  .find(([_, value]) => value === 'Y');
                const targetDay = dayEntry ? dayEntry[0] : null;

                if (targetWeek && targetDay) {
                  const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
                  const targetDayNum = dayMap[targetDay];

                  if (targetDayNum !== undefined) {
                    // Calculate days to add to reach target day
                    let daysToAdd = (targetDayNum - date.getDay() + 7) % 7;
                    date.setDate(date.getDate() + daysToAdd);

                    // Add weeks to get to target week
                    const weekNumber = parseInt(targetWeek.replace('week', ''));
                    date.setDate(date.getDate() + (weekNumber - 1) * 7);
                  }
                }
              }

              // If this date is in the past, add a year
              if (date < today) {
                date.setFullYear(year + 1);
              }

              return date;
            });

            // Find the next occurrence (first date that's in the future)
            const nextDate = possibleDates.sort((a, b) => a - b).find(date => date > today);

            if (nextDate) {
              return nextDate.toLocaleDateString('default', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
              });
            }
          }
          break;

        // case 'biannually':
        case 'semi-annually':
          if (row.repeat_quarters) {
            const activeQuarters = Object.entries(row.repeat_quarters)
              .filter(([_, value]) => value === 'Y')
              .map(([quarter]) => parseInt(quarter.substring(1)));

            const nextHalfYear = activeQuarters.find(q => q > currentQuarter) || activeQuarters[0];
            const quarterStartMonths = [0, 3, 6, 9]; // Jan, Apr, Jul, Oct
            const nextYear = today.getFullYear() + (nextHalfYear <= currentQuarter ? 1 : 0);
            const nextDate = new Date(nextYear, quarterStartMonths[nextHalfYear - 1], 1);
            return nextDate.toLocaleDateString('default', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            });
          }
          break;

        case 'weekly':
          if (nextDay) {
            const daysToAdd = (7 + ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(nextDay) - today.getDay()) % 7;
            const nextDate = new Date(today);
            nextDate.setDate(today.getDate() + daysToAdd);
            return nextDate.toLocaleDateString();
          }
          break;

        case 'monthly':
          if (row.repeat_weeks && row.repeat_days) {
            const today = new Date();
            
            // Get the target week and day
            const weekEntry = Object.entries(row.repeat_weeks)
              .find(([_, value]) => value === 'Y');
            const targetWeek = weekEntry ? weekEntry[0] : null;
            
            const dayEntry = Object.entries(row.repeat_days)
              .find(([_, value]) => value === 'Y');
            const targetDay = dayEntry ? dayEntry[0] : null;

            if (targetWeek && targetDay) {
              // Convert day name to day number (0-6)
              const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
              const targetDayNum = dayMap[targetDay];

              if (targetDayNum !== undefined) {
                // Start with the first day of current/next month
                const nextDate = new Date(today.getFullYear(), 
                  today.getMonth() + (nextWeek < currentWeek ? 1 : 0), 
                  1);

                // Calculate days to add to reach target day
                let daysToAdd = (targetDayNum - nextDate.getDay() + 7) % 7;
                nextDate.setDate(nextDate.getDate() + daysToAdd);

                // Add weeks to get to target week
                const weekNumber = parseInt(targetWeek.replace('week', ''));
                nextDate.setDate(nextDate.getDate() + (weekNumber - 1) * 7);

                // If the calculated date is in the past, move to next month
                if (nextDate < today) {
                  nextDate.setMonth(nextDate.getMonth() + 1);
                }

                return nextDate.toLocaleDateString('default', {
                  month: 'short',
                  day: 'numeric', 
                  year: 'numeric'
                });
              }
            }
          }
          break;

        case 'bi-monthly':
          if (nextWeek && nextDay) {
            // Calculate next bi-monthly occurrence
            let monthsToAdd = 2 - (currentMonth % 2);
            if (nextWeek < currentWeek) monthsToAdd += 2;
            const nextDate = new Date(today.getFullYear(), today.getMonth() + monthsToAdd);
            return `Week ${nextWeek}, ${nextDate.toLocaleString('default', { month: 'short' })} ${nextDate.getFullYear()}`;
          }
          break;

        case 'yearly':
          if (row.repeat_months && row.repeat_weeks && row.repeat_days) {
            const targetMonth = row.repeat_months;

            // Convert month name to month number (0-11)
            const monthMap = {
              January: 0, February: 1, March: 2, April: 3, May: 4, June: 5,
              July: 6, August: 7, September: 8, October: 9, November: 10, December: 11
            };
            const targetMonthNum = monthMap[targetMonth];

            // Get the target week and day
            const weekEntry = Object.entries(row.repeat_weeks)
              .find(([_, value]) => value === 'Y');
            const targetWeek = weekEntry ? weekEntry[0] : null;

            const dayEntry = Object.entries(row.repeat_days)
              .find(([_, value]) => value === 'Y');
            const targetDay = dayEntry ? dayEntry[0] : null;

            if (targetMonthNum !== undefined && targetWeek && targetDay) {
              // Convert day name to day number (0-6)
              const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
              const targetDayNum = dayMap[targetDay];

              if (targetDayNum !== undefined) {
                // Use current year for initial calculation
                const nextDate = new Date(today.getFullYear(), targetMonthNum, 1);

                // Calculate days to add to reach target day
                let daysToAdd = (targetDayNum - nextDate.getDay() + 7) % 7;
                nextDate.setDate(nextDate.getDate() + daysToAdd);

                // Add weeks to get to target week
                const weekNumber = parseInt(targetWeek.replace('week', ''));
                nextDate.setDate(nextDate.getDate() + (weekNumber - 1) * 7);

                // If the calculated date is in the past, move to next year
                if (nextDate < today) {
                  nextDate.setFullYear(today.getFullYear() + 1);
                }

                return nextDate.toLocaleDateString('default', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric'
                });
              }
            }
          }
          break;
      }

      return null;
    },
    handleSortChange({ prop, order }) {
      if (!prop || !this.questions) return;

      const sortedQuestions = [...this.questions].sort((a, b) => {
        const dateA = this.getNextOccurrence(a);
        const dateB = this.getNextOccurrence(b);

        // Helper function to check if a value is a valid date
        const isValidDate = (value) => {
          if (!value) return false;
          const date = new Date(value);
          return date instanceof Date && !isNaN(date) && value !== '-' && value !== 'Follow-up';
        };

        // If both are dates
        if (isValidDate(dateA) && isValidDate(dateB)) {
          const comparison = new Date(dateA) - new Date(dateB);
          return order === 'ascending' ? comparison : -comparison;
        }

        // If only one is a date
        if (isValidDate(dateA)) return -1;
        if (isValidDate(dateB)) return 1;

        // Neither is a date, handle special values
        const specialValues = {
          'Follow-up': 1,
          '-': 2
        };

        const valueA = specialValues[dateA] || 2;
        const valueB = specialValues[dateB] || 2;

        const comparison = valueA - valueB;
        return order === 'ascending' ? comparison : -comparison;
      });

      this.$store.commit('question/setQuestions', sortedQuestions);
    }
  },
};
</script>
<style lang="scss" scoped>
.menuOptionStyle {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
  margin-top: 0px;
  margin-right: 48px;
}

.button {
  width: 95px;
}

.btnActionView {
  font-size: 15px;
}

.btnDisableView {
  font-size: 15px;
  background: #f4f4f5;
  opacity: 0.4;
}

.txtResponse {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  margin: 0 24px;
  word-wrap: normal;
  word-break: normal;
}

.txtAllSummary {
  font-weight: 700;
  font-size: 15px;
  color: #505050;
  word-wrap: normal;
  word-break: normal;
}

.txtRepeats {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-normal) 13px/16px var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal normal 13px/16px Lato;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.6;
}

.divAllSummary {
  margin: 0 24px;
}

.txtHeaderStrategic {
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  color: var(--unnamed-color-000000);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #000000;
  // margin: 0 0 0 24px;
}

.txtHeaderSummary {
  margin: 0 24px;
  font: var(--unnamed-font-style-normal) normal var(--unnamed-font-weight-bold) var(--unnamed-font-size-15)/var(--unnamed-line-spacing-18) var(--unnamed-font-family-lato);
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  font: normal normal bold 15px/18px Lato;
  letter-spacing: 0px;
  color: #6C30CC;
  opacity: 1;
}

.txtTotalResponse {
  font-weight: 700;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.3);
  margin-right: 20px;
}

.txtDropdown {
  font-weight: 700;
  font-size: 18px;
  color: #000000;
  cursor: pointer;
}

.shadowBottom {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 10px 6px -6px;
  height: 16px;
  background: #fff;
  margin-left: -20px;
  margin-right: -20px;
}

.txtTeam {
  font-weight: 700;
  font-size: 13px;
  line-height: 16px;
  color: #505050;
  width: 170px;
  padding-top: 2px;
}

.txtYes {
  font-weight: 700;
  font-size: 15px;
  color: #66bb6a;
}

.txtNo {
  font-weight: 700;
  font-size: 15px;
  color: #f44336;
}

.progressYes {
  height: 18px;
  background: #66bb6a;
  margin-left: 4px;
  border-radius: 3px;
}

.progressNo {
  height: 18px;
  background: #f44336;
  margin-left: 4px;
  border-radius: 3px;
}

.empty-table {
  width: 100%;
  height: 320px;
  text-align: center;
  line-height: 320px;
}

.rowItem {
  height: 50px;
  width: 260px;
  background: #f7f7f7;
}

.headerYesNo {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 2px;
}

.headerOpenEnded {
  display: flex;
  justify-content: space-between;
}

.icon-export {
  // padding-right: 8px;
  color: #000;
  margin-right: 10px;
}

div.el-table__body-wrapper.is-scrolling-none {
  height: 520px;
}

.dropdownHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding-left: 24px;
  padding-right: 16px;
  margin-bottom: 10px;
  background: #f8f8f8;
  border-bottom: 1px solid #e8e8e8;
}

.dropdownHeaderTextStyle {
  font-size: 13px;
  font-weight: 700;
}

.el-button--text.dropdownHeaderTextStyle {
  color: #32c2d5;
}

.el-button--text.dropdownHeaderTextStyle:hover {
  color: #249fb0;
}

.el-button--text.dropdownHeaderTextStyle:active {
  color: #32c2d5;
}

.tooltipStyle {
  max-width: 240px;
}

.dropdownFooter {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 56px;
  padding-right: 16px;
  background: #f8f8f8;
  border-top: 1px solid #e8e8e8;

  .el-button--cancel {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .el-button--cancel:hover,
  .el-button--cancel:focus {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 0.7;
  }

  .el-button--cancel:active {
    color: #747474;
    background-color: #e0e0e0;
    border-color: #e0e0e0;
    opacity: 1;
  }

  .el-button--save {
    padding: 4px 16px;
    height: 24px;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
  }

  .el-button--save:hover,
  .el-button--save:focus {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 0.7;
  }

  .el-button--save:active {
    color: #fff;
    background-color: #32c2d5;
    border-color: #32c2d5;
    opacity: 1;
  }
}

.el-dropdown-menu {
  width: 280px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 1px solid #e8e8e8;
}

.el-dropdown-menu__item {
  font-size: 13px;
  font-weight: 700;
  color: #292929;
  height: 24px;
  padding-bottom: 8px;
}

.el-dropdown-menu__item:hover,
.el-dropdown-menu__item:focus {
  cursor: default;
  background-color: initial !important;
}


.drop-down-container {
  margin-left: 12px;
  height: 40px;
  border-radius: 4px;
  padding: 0 8px 0 12px;
}

.drop-down-container.active {
  margin-left: 10px;
  background-color: rgba(#32C2D5, 0.1);
  padding: 0 6px 0 10px;
}

.text-drop-down {
  color: #00ACC1;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.drop-down-close {
  position: absolute;
  top: -12px;
  transform: rotate(45deg);
  width: 24px;
  height: 24px;
  margin-left: 4px;

  .x-btn {
    position: relative;
    width: 24px;
    height: 24px;
    cursor: pointer;

    &:before,
    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      content: "";
      background-color: #747474;
      transition: 0.3s;
    }

    &:before {
      width: 2px;
      height: 20px;
    }

    &:after {
      width: 20px;
      height: 2px;
    }

    &:hover {

      &:before,
      &:after {
        background-color: #333;
      }
    }
  }
}

.txtHeaderModal {
  font-size: 20px;
  color: #2f2f2f;
  font-weight: 800;
}

.summaryLayout {
  background: #6C30CC08 0% 0% no-repeat padding-box;
  border: 1px solid #6C30CC;
  border-radius: 7px;
  opacity: 1;
}

.talkingPointsBox {
  height: 40px;
}

.talking-points {
  border-width: 0;
  border-radius: 16px;
  font-weight: 700;
  // box-shadow: 0px 2px 4px #00000029;
  transition: 0.2s;
  margin: 8px 8px 0 0;

  &:hover {
    margin-top: 5px;
    // box-shadow: 0px 5px 6px #00000019;
    margin-bottom: 3px;
  }
}

.tooltipStyleTalkingPoints {
  width: 375px;
  padding: 8px;
}

.tooltip-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  padding-top: 11px;
}

.tooltip-item p {
  margin: 0;
  font-size: 12px;
}

.oi-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  min-height: 24px;
  border-radius: 50%;
  background-color: rgba(108, 48, 204, 0.2);
  /* สีพื้นหลัง */
  // opacity: 0.2;
  color: #6C30CC;
  /* สีตัวอักษร */
  font-weight: bold;
  margin-right: 12px;
}

.GreenBoxStyle {
  color: #249d2a;
  background-color: #edffee;
}

.RedBoxStyle {
  color: #f44336;
  background-color: #ffedeb;
}

.GreyBoxStyle {
  color: #484848;
  // border-color: #b2b2b2;
  background-color: #f0f0f0;
}

.lh-14 {
  line-height: 14px;
}
</style>
<style lang="scss">
#standardQuestion i.el-dialog__close.el-icon.el-icon-close {
  font-size: 26px;
  margin-top: 12px;
}

#standardQuestion i.el-select__caret.el-input__icon.el-icon-arrow-up {
  color: #000;
  font-size: 16px;
  font-weight: bold;
}

#standardQuestion i.el-icon-caret-right {
  margin-top: 20px;
  cursor: pointer;
}

#standardQuestion .bar-results,
#questionsCustom .bar-results {
  height: 50px;
  text-align: center;
  color: #fff;
  padding-top: 16px;
  font-size: 16px;
}

#standardQuestion .box,
#questionsCustom .box {
  height: 20px;
  width: 20px;
  border-radius: 4px;
}

// #standardQuestion .bar-results:nth-child(1),
// #questionsCustom .bar-results:nth-child(1) {
//   border-radius: 4px 0 0 4px;
// }
// #standardQuestion .bar-results:nth-last-child(1),
// #questionsCustom .bar-results:nth-last-child(1) {
//   border-radius: 0 4px 4px 0;
// }
.box.color-1,
#standardQuestion .bar-results.color-1,
#questionsCustom .bar-results.color-1 {
  background-color: #d33e3e;
}

.box.color-2,
#standardQuestion .bar-results.color-2,
#questionsCustom .bar-results.color-2 {
  background-color: #ff4e4e;
}

.box.color-3,
#standardQuestion .bar-results.color-3,
#questionsCustom .bar-results.color-3 {
  background-color: #eed24e;
}

.box.color-4,
#standardQuestion .bar-results.color-4,
#questionsCustom .bar-results.color-4 {
  background-color: #76ca7d;
}

.box.color-5,
#standardQuestion .bar-results.color-5,
#questionsCustom .bar-results.color-5 {
  background-color: #00b383;
}

.box.color-6,
#standardQuestion .bar-results.color-6,
#questionsCustom .bar-results.color-6 {
  background-color: #068462;
}

#openEndedTable div.el-table__body-wrapper.is-scrolling-none {
  height: 470px !important;
}
</style>